module.exports = __webpack_public_path__ + "img/my-coin.79b498ea.png";